import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { addFavoriteMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useAddFavoriteMeal = (currentDay) => {
    const [isAdding, setIsAdding] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: addFavoriteMeal,
        onError: (error) => console.error('Failed to add favorite meal:', error)
    });

    const addFavoriteMealAndSync = async (payload) => {
        setIsAdding(true);

        try {
            const res = await mutation.mutateAsync(payload);

            await refetchDiaryAndEnergy(queryClient, currentDay);

            return res?.meal_id;
        } catch (error) {
            console.error('Add favorite meal and sync failed:', error);
        } finally {
            setIsAdding(false);
        }
    };

    return {
        addFavoriteMeal: addFavoriteMealAndSync,
        isAdding,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useAddFavoriteMeal;
